import { useMemo } from "react"
import { NpProductColorCardValueProps } from "src/components/product-details/buyBox/NpProductColorCards"

export function useCheapestPrice(options: NpProductColorCardValueProps[]) {
  return useMemo(() => {
    let pricesDiffer = false

    const cheapestPrice = options.reduce((cheapest, current) => {
      pricesDiffer ||= current.product.resolvedPrice !== cheapest.product.resolvedPrice
      if (current.product.resolvedPrice < cheapest.product.resolvedPrice) {
        return current
      }
      return cheapest
    }, options[0]!).product.resolvedPrice

    return { pricesDiffer, cheapestPrice }
  }, [options])
}
